import API from '../../../../../services/api';

export const CHECKOUT_API = {
    transferDone: async (checkoutId, data) => {
        return API.post('/crm-transfer-done/' + checkoutId, data).then(res => res.data);
    },
    transferDenied: async (checkoutId, data) => {
        return API.post('/checkout-transfer-denied/' + checkoutId, data).then(res => res.data);
    }
}
